import { observable } from 'mobx';
import moment from '@this/lib/moment';

export type ShippingElementResponseArgs = {
  id: number;
  category_text: string;
  shipped_at: string;
  arrived_at: string;
};

export type ShippingElementArgs = {
  id: number;
  categoryText: string;
  shippedAt: moment.Moment;
  arrivedAt: moment.Moment;
};

export const convertShippingElementResponseToArgs = (response: ShippingElementResponseArgs) => {
  const args: ShippingElementArgs = {
    id: response.id,
    categoryText: response.category_text,
    shippedAt: moment(response.shipped_at),
    arrivedAt: response.arrived_at ? moment(response.arrived_at) : moment(response.shipped_at).add(1, 'day')
  };
  return args;
};

export default class ShippingElement {
  @observable id: number;
  @observable categoryText: string;

  @observable
  shippedAt: moment.Moment;

  @observable
  arrivedAt: moment.Moment;

  constructor(args: ShippingElementArgs) {
    this.id = args.id;
    this.categoryText = args.categoryText;
    this.shippedAt = args.shippedAt;
    this.arrivedAt = args.arrivedAt;
  }

  get type() {
    return 'shipping';
  }

  get startDate() {
    return this.shippedAt;
  }

  get endDate() {
    return this.arrivedAt;
  }

  get title() {
    return '配送料';
  }

  get summary() {
    return `[配送料]${this.categoryText}`;
  }

  get name() {
    return this.title;
  }

  get mappingDescription() {
    return this.title;
  }

  detail() {
    return '';
  }
}
